<div class="container-fluid">
    <app-progress></app-progress>
    <alert></alert>
</div>
<router-outlet></router-outlet>